module.exports = __webpack_public_path__ + "img/logo.2f97eb0d.png";